import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faBars, faPlus, faArrowLeft, faTimes } from '@fortawesome/free-solid-svg-icons';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { MdAddLocationAlt } from 'react-icons/md';
import { useNavigate, useLocation } from 'react-router-dom';
import ProjectImage from './images/ProjectImage.png';
import Map from './images/Map.png';
import { faImage as faRegularImage } from '@fortawesome/free-regular-svg-icons';
import Building2 from './images/Building2.png';
// Add this import at the top with other imports
// Update your existing import
import Loader, { SmallInlineLoader } from './Component/Loader';
import imageCompression from 'browser-image-compression';
import ArrowLeft from './images/ArrowLeft.png';


      /* global google */  

let currentInfoWindow = null;

function AddProject() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [projectName, setProjectName] = useState('');
  const [projectStage, setProjectStage] = useState('');
  const [address, setAddress] = useState('');
  const CreateProjectURL = process.env.REACT_APP_FORE_APILINK + '/projects/create-project';
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const [projectImage, setProjectImage] = useState(ProjectImage);
  const [imageFile, setImageFile] = useState(null);
  const fileInputRef = useRef(null);
  
  const [locations, setLocations] = useState([{ProjectName:'', BuilderName:''}]);
  const [showStageDropdown, setShowStageDropdown] = useState(false);
  const stageDropdownRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
const [isCreatingProject, setIsCreatingProject] = useState(false);
const [isMapFullyLoaded, setIsMapFullyLoaded] = useState(false);
const [showSuccessPopup, setShowSuccessPopup] = useState(false);
const [isImageUploading, setIsImageUploading] = useState(false);
const [stages, setStages] = useState([]);


  // Fetch user's live location on component mount
 useEffect(() => {
  fetchCurrentLocation(); // Use the single function
}, []);

  

  const handleUploadButtonClick = () => {
    fileInputRef.current.click();
  };
  
const handleFileChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    setIsImageUploading(true);

    try {
      // Compress the image
      const compressedFile = await imageCompression(file, {
        maxSizeMB: 0.5, 
        maxWidthOrHeight: 1024,
        useWebWorker: true
      });

      setImageFile(compressedFile); 

      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage(e.target.result);
        setIsImageUploading(false);
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error('Error compressing image:', error);
      setIsImageUploading(false);
    }
  }
};



useEffect(() => {
  const fetchStages = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(
        process.env.REACT_APP_FORE_APILINK + "/projects/get-stage-of-construction",
        { headers: { "x-token": token } }
      );
      const data = await res.json();
      if (data.success) {
        setStages(data.data);
      }
    } catch (err) {
      console.error("Error fetching stages:", err);
    }
  };

  fetchStages();
}, []);


  
const fetchCurrentLocation = async () => {
  if (!navigator.geolocation) {
    console.error('Geolocation is not supported by your browser');
    return;
  }
  
  setIsMapFullyLoaded(false); // Reset map loaded state
  
  try {
    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    };

    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });

    setCoordinates({
      lat: position.coords.latitude,
      lng: position.coords.longitude
    });

    const results = await geocodeByAddress(`${position.coords.latitude},${position.coords.longitude}`);
    const address = results[0].formatted_address;
    setAddress(address);
    
  } catch (error) {
    if (error.code === error.PERMISSION_DENIED) {
      console.error('User denied the request for Geolocation.');
    } else if (error.code === error.POSITION_UNAVAILABLE) {
      console.error('Location information is unavailable.');
    } else if (error.code === error.TIMEOUT) {
      console.error('The request to get user location timed out.');
    } else {
      console.error('An unknown error occurred:', error);
    }
  }
};


  
  

  const clearAddress = () => {
    setAddress('');
    setCoordinates({ lat: 0, lng: 0 });
  };

  const handleSelect = async (address) => {
  setAddress(address);
  setIsMapFullyLoaded(false); // Reset map loaded state

  // Blur the input to close the mobile keyboard
  if (document.activeElement) {
    document.activeElement.blur();
  }

  try {
    const results = await geocodeByAddress(address);
    const latLng = await getLatLng(results[0]);
    setCoordinates(latLng);
  } catch (error) {
    console.error('Error:', error);
  }
};



const handleChange = (address) => {
  setAddress(address);
  
  // Show loading when user starts typing
  if (address.length > 0) {
    setIsMapFullyLoaded(false);
    
    // Clear loading after 5 seconds if no selection is made
    setTimeout(() => {
      setIsMapFullyLoaded(true); // Changed from false to true
    }, 2000);
  }
};




  


  useEffect(() => {
    if(coordinates && coordinates.lat !== 0 && coordinates.lng !== 0) {
      renderMap();
    }
  }, [coordinates]);

  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        if (window.google && window.google.maps) {
          window.google.maps.event.trigger(window.google.maps, 'resize');
        }
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderMap = () => {
  if (!coordinates || !coordinates.lat || !coordinates.lng) {
    return;
  }
  
  const mapElement = document.getElementById('map');
  if (!mapElement) return;
  
  mapElement.innerHTML = '';
  
  const map = new window.google.maps.Map(mapElement, {
    center: { lat: coordinates.lat, lng: coordinates.lng },
    zoom: 8
  });

  // Set map as loaded when it's ready
  google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
    setIsMapFullyLoaded(true);
  });

  // Map click handler
  map.addListener('click', async (event) => {
    const clickedLat = event.latLng.lat();
    const clickedLng = event.latLng.lng();
    
    setCoordinates({
      lat: clickedLat,
      lng: clickedLng
    });

    try {
      const results = await geocodeByAddress(`${clickedLat},${clickedLng}`);
      const clickedAddress = results[0].formatted_address;
      setAddress(clickedAddress);
    } catch (error) {
      console.error('Error getting address:', error);
    }
  });

  // Add markers for locations
  locations.forEach(location => {
    const marker = new window.google.maps.Marker({
      position: { lat: location.lat, lng: location.lng },
      map: map,
      title: location.name
    });

    const infoWindow = new window.google.maps.InfoWindow({
      content: location.name
    });

    marker.addListener('click', () => {
      infoWindow.open(map, marker);
    });
  });

  // Add marker for current selected coordinates
  if (coordinates.lat && coordinates.lng) {
    new window.google.maps.Marker({
      position: { lat: coordinates.lat, lng: coordinates.lng },
      map: map,
      title: 'Selected Location'
    });
  }
};



  useEffect(() => {
    function handleClickOutside(event) {
      if (stageDropdownRef.current && !stageDropdownRef.current.contains(event.target)) {
        setShowStageDropdown(false);
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem('userData');
    if (storedData) {
      setUserData(JSON.parse(storedData));
    }
  }, []);

const handleProjectSubmit = async () => {
  try {
     setIsCreatingProject(true)
    const token = sessionStorage.getItem('token');

    // Validate project name
    if (!projectName || projectName.trim() === '') {
      alert('Project name is required');
      return;
    }

    // Additional validations
    if (!address || address.trim() === '') {
      alert('Project location is required');
      return;
    }

    if (!coordinates.lat || !coordinates.lng) {
      alert('Please select a valid location');
      return;
    }

    // Create FormData to handle file upload
    const formData = new FormData();
    
    // Append project data
    formData.append('customer_id', userData._id);
    formData.append('projectName', projectName);
    formData.append('stageofconstruction', projectStage); // Match backend field name
    formData.append('latitude', coordinates.lat);
    formData.append('longitude', coordinates.lng);
    formData.append('siteAddress', address);
    formData.append('hubId', sessionStorage.getItem('hubId'));
    
    // Append image file if selected - use 'projectImage' to match backend multer field name
    if (imageFile) {
      formData.append('projectImage', imageFile); // This matches the multer field name
    }

    const response = await fetch(CreateProjectURL, {
      method: 'POST',
      headers: {
        'x-token': token
        // Don't set Content-Type header when using FormData
      },
      body: formData, // Send FormData instead of JSON
    });

    const data = await response.json();
    console.log('Response from server:', data);

    // if (response.ok) {
    //   console.log('Project created successfully');
    //   setShowSuccessPopup(true);
      
    //  setTimeout(() => {
    //     setIsCreatingProject(false);
    //     setShowSuccessPopup(true);
        
    //     // Hide popup after 2 seconds and navigate
    //     setTimeout(() => {
    //       setShowSuccessPopup(false);
    //       const projectId = data.projectId || data._id || data.project?._id;
          
    //       if (projectId) {
    //         navigate('/consumer/viewproject', {
    //           state: { projectId: projectId }
    //         });
    //       }
    //     }, 2000);
    //   }, 2000);
      
    // } else {
      if (response.ok) {
  console.log("Project created successfully");
  setShowSuccessPopup(true);

  setTimeout(() => {
    setIsCreatingProject(false);
    setShowSuccessPopup(true);

    // Hide popup after 2 seconds and navigate
    setTimeout(() => {
      setShowSuccessPopup(false);

      // 🔴 Removed projectId usage
      // ✅ Navigate directly to ProjectDetails page and open popup
      navigate("/consumer/projectdetails", {
        state: { showProjectPopup: true }, // only pass popup flag
      });
    }, 2000);
  }, 2000);
} else {
      throw new Error(data.message || 'Error creating project');
    }
  } catch (error) {
    console.error('Error creating project:', error.message);
    alert(`Failed to create project: ${error.message}`);
  } finally {
    setIsCreatingProject(false);
  }
};



  const handleSkip = () => {
    navigate("/consumer/app/home");
    console.log('skipped');
  };

  return (
   <div className="flex flex-col w-full min-h-screen">
  {/* Main header title - Made sticky */}
  <div className="w-full px-2 py-4 sticky top-0 z-10 border-b border-gray-200 bg-white">
  <div className="flex items-center">
    <img
      src={ArrowLeft} 
      className="w-10 h-6 text-gray-600 cursor-pointer" 
      onClick={() => navigate(-1)}
    />
    <h1 className="text-[#0D0C0C] font-medium text-md">Add Project</h1>
  </div>
</div>


  {/* Main content */}
  <div className="px-4 py-6 flex flex-col items-center">
    {/* Project image upload section - Added top margin */}
   <div className="w-full flex flex-col items-center mb-3 mt-6">
  <div
    className={`w-50 h-34 mb-4 flex justify-center items-center rounded-lg overflow-hidden ${
      selectedImage ? 'border border-gray-200' : ''
    }`}
    onClick={handleUploadButtonClick}
  >
    {isImageUploading ? (
      <div className="w-48 h-48 flex flex-col items-center justify-center">
        <div className="w-8 h-8 border-2 border-red-500 border-t-transparent rounded-full animate-spin mb-2"></div>
        <span className="text-gray-500 text-sm">Uploading...</span>
      </div>
    ) : selectedImage ? (
      <img
        src={selectedImage}
        alt="Selected project"
        className="w-48 h-48 cursor-pointer object-cover"
      />
    ) : (
      <img
        src={Building2}
        alt="Upload project"
        className="h-full w-full cursor-pointer object-contain"
      />
    )}
  </div>
          
  {/* Hidden file input */}
  <input
    type="file"
    ref={fileInputRef}
    onChange={handleFileChange}
    accept="image/*"
    className="hidden"
  />
          
  <button
    className="text-[#000000] flex items-center text-md"
    onClick={handleUploadButtonClick}
  >
    {selectedImage ? 'Change Project Image' : 'Upload Project Image'}
  </button>
</div>

        {/* Form section */}
        <div className="w-full mt-6 px-2">
          <h2 className="text-lg font-medium text-[#0D0C0C] mb-4">Enter Project Details</h2>
          
          {/* Project Name Input */}
        <div className="mb-4">
    <input
        type="text"
        value={projectName}
        onChange={(e) => setProjectName(e.target.value)}
        className={`appearance-none border ${errors.projectName ? 'border-red-500' : 'border-gray-300'} rounded w-full py-6 px-4 text-gray-700 text-sm leading-tight focus:outline-none focus:border-red-700 h-14 placeholder:text-[#A8A1A1] placeholder:font-semibold placeholder:text-md`}
        placeholder="Name of the Project"
    />
    {errors.projectName && (
        <div className="mt-2 p-2 bg-red-50 border-l-4 border-red-500 text-red-700">
            {errors.projectName}
        </div>
    )}
</div>


          {/* Project Stage Dropdown */}
     <div className="mb-4 relative" ref={stageDropdownRef}>
    <div
        className={`border ${errors.projectStage ? 'border-red-500' : 'border-gray-300'} rounded w-full py-3 px-3 text-gray-700 text-sm leading-tight focus:outline-none h-14 bg-[#E0D9D9]/45 flex justify-between items-center cursor-pointer`}
        onClick={() => setShowStageDropdown(!showStageDropdown)}
    >
        <span className={projectStage ? "text-gray-700" : "text-[#A8A1A1] font-semibold text-md"}>
            {projectStage || "Stage of Construction"}
        </span>
        <svg
            className={`fill-current h-4 w-4 text-gray-500 transition-transform duration-200 ${showStageDropdown ? 'transform rotate-180' : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
        >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
        </svg>
    </div>
                   
    {/* Dropdown Menu */}
   {showStageDropdown && (
  <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
    {stages.map((stage, index) => (
      <div
        key={index}
        className="py-2.5 px-4 hover:bg-gray-50 cursor-pointer text-gray-700 text-base"
        onClick={() => {
          setProjectStage(stage);
          setShowStageDropdown(false);
        }}
      >
        {stage}
      </div>
    ))}
  </div>
)}

    {errors.projectStage && (
        <div className="mt-2 p-2 bg-red-50 border-l-4 border-red-500 text-red-700">
            {errors.projectStage}
        </div>
    )}
</div>



          {/* Location Selection with Map Icon and Clear Button */}
         <div className="mb-6">
  <div className="relative">
    <PlacesAutocomplete value={address} onChange={handleChange} onSelect={handleSelect}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <div className="relative">
            <input
              {...getInputProps({
                placeholder: 'Select Location from Map',
                className: `border ${errors.address ? 'border-red-500' : 'border-gray-300'} rounded w-full py-3 px-3 text-gray-700 text-sm leading-tight focus:outline-none focus:border-red-700 h-14 pr-20 placeholder:text-[#A8A1A1] placeholder:font-semibold placeholder:text-md`
              })}
            />
            {/* Clear button - only show when there's text */}
            {address && (
              <div 
                className="absolute inset-y-0 right-12 flex items-center pr-2 cursor-pointer"
                onClick={clearAddress}
              >
                <div className="w-5 h-5 bg-gray-400 rounded-full flex items-center justify-center hover:bg-gray-500">
                  <FontAwesomeIcon 
                    icon={faTimes} 
                    className="w-3 h-3 text-white"
                  />
                </div>
              </div>
            )}
            {/* Map icon */}
            <div 
              className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
              onClick={fetchCurrentLocation}
            >
              <img 
                src={Map} 
                alt="Map" 
                className="h-6 w-6 object-contain"
              />
            </div>
          </div>
          <div className="autocomplete-dropdown-container bg-white rounded shadow-lg absolute z-50 w-full">
            {loading && <div className="p-2">Loading...</div>}
            {suggestions.map(suggestion => {
              const className = suggestion.active
                ? 'suggestion-item--active p-2 bg-blue-500 text-white'
                : 'suggestion-item p-2';
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className
                  })}
                  key={suggestion.placeId}
                >
                  {suggestion.description}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
    {errors.address && (
      <div className="mt-2 p-2 bg-red-50 border-l-4 border-red-500 text-red-700">
        {errors.address}
      </div>
    )}
  </div>
</div>

{/* Map display */}
<div className="mb-24">
  <div className="relative">
    <div 
      id="map" 
      className="w-full h-48 border border-gray-300 rounded"
      style={{ minHeight: '200px' }}
    />
  {!isMapFullyLoaded && coordinates.lat !== 0 && coordinates.lng !== 0 && (
  <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-90 z-10 rounded">
    <div className="w-6 h-6 border-2 border-red-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
)}

  </div>
</div>



   <div className="fixed bottom-0 left-0 right-0 bg-white px-2 border-t border-gray-200" style={{ zIndex: 9999, position: 'fixed', height: '100px', paddingTop: '20px' }}>
  <button
  onClick={handleProjectSubmit}
  disabled={isCreatingProject}
  className={`font-semibold text-md rounded-md px-2 py-3 w-6/7 mx-auto block transition duration-300 shadow-md ${
    isCreatingProject 
      ? 'bg-[#D93025] text-white cursor-wait' 
      : 'bg-[#D93025] text-white hover:bg-[#D93025]'
  }`}
>
  <div className="flex items-center justify-center">
    <span>Submit</span>
    {isCreatingProject && <SmallInlineLoader />}
  </div>
</button>

</div>




        </div>
      </div>
      {/* Success Popup */}
{showSuccessPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 mx-4 max-w-sm w-full text-center shadow-xl">
      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">Success!</h3>
      <p className="text-gray-600">Project created successfully</p>
    </div>
  </div>
)}

    </div>
  );
}

export default AddProject;
